<template>

    <oa-modal :name="name">
        <template slot="header">
            <img v-if="agentExperiments.SDPLeadActionBtns" class="modal-icon" src="@/assets/images/helpme.svg"/>
            <img v-else class="modal-icon" src="@/assets/images/pass-lead.svg"/>
            <span>OpenAgent to help me</span>
        </template>
        <template slot="description">
            While we are following up with the vendor, the lead will be removed from your active list.
            Please let us know why you want us to follow up.
        </template>

        <template slot="body">
            <div class="form-group">
                <label for="comments">Comments</label>
                <textarea id="comments" rows="5" v-model="comment"></textarea>
            </div>
        </template>

        <template slot="error">
            <span v-if="errorMsg !== ''" id="error-message" class="error inline">
                {{ errorMsg }}
            </span>
        </template>

        <template slot="footer">
            <div>
                <button class="btn btn-green" :disabled="disableSubmit" @click="declineLead()">
                    Confirm
                </button>
                <button class="btn btn-small white-bg ut-ml-4"  @click="closeModal()">
                    Cancel
                </button>
            </div>
        </template>

    </oa-modal>

</template>

<script>
import OaModal from '@/components/Modals/OaModal.vue';
import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'GiveLeadBackModal',
  components: { OaModal },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
      agentExperiments: state => state.experimentStore.agentExperiments,
    }),
    ...mapGetters('leadAgentMappingStore', [
      'lamIsOnHoldIgnoredLead',
    ]),
  },
  data() {
    return {
      name: 'give-lead-back-modal',
      disableSubmit: false,
      comment: '',
      errorMsg: '',
    };
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadAgentMapping',
    ]),
    ...mapActions('agentStore', [
      'updateAgent',
    ]),
    closeModal() {
      this.resetFormView();
      this.$modal.hide(this.name);
    },
    resetFormView() {
      this.disableSubmit = false;
      this.comment = '';
      this.errorMsg = '';
    },
    validateDecline() {
      this.errorMsg = '';
      if (this.comment.length === 0) {
        this.setError('Please specify a reason in comments.');
        return false;
      }
      return true;
    },
    setError(msg) {
      if (this.errorMsg.length === 0) {
        this.errorMsg = msg;
      }
    },
    declineLead() {
      if (!this.validateDecline()) {
        return false;
      }
      /**
       * If the agent is on hold
       * because of ignoring lead
       * then put him off hold
       */
      this.onHoldIgnoredLeadUpdate();
      this.disableSubmit = true;
      const payload = {
        lamid: this.lam.id,
        data: {
          statetypeid: LeadAgentLeadStateType.Closed,
          leaddeclinedreasoncomment: this.comment,
          leaddeclinedreason: 'Give back to OpenAgent',
          oauserid: !!this.user ? this.user.id : '',
          oauserkey: !!this.user ? this.user.key : '',
        },
      };
      this.updateLeadAgentMapping(payload)
        .then(() => {
          this.closeModal();
          this.disableSubmit = false;
          window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls to the top of the page
        }).catch((err) => {
          // Probably want to do something :)
          this.disableSubmit = false;
          console.log(err);
        });

      return true;
    },
    onHoldIgnoredLeadUpdate() {
      if (this.lamIsOnHoldIgnoredLead) {
        const payload = {
          data: {
            agentid: this.lam.agentid,
            // agentid: this.agent.id,
            leadid: this.lead.id,
            onhold: 0,
            eventsource: 'API',
          },
        };

        this.updateAgent(payload)
          .then(() => {})
          .catch((err) => {
            // Probably want to do something :)
            console.log(err);
          });
      }
    },
  },
};


</script>

<style scoped lang="scss">


</style>
